import { SidebarMenuButton } from "@/components/ui/sidebar.tsx";
import { useLingui } from "@lingui/react";
import { useEditUserProfileMutation, USER_PROFILE_KEY } from "@/modules/user/api/useUser.ts";
import { useQueryClient } from "@tanstack/react-query";
import { useMeData } from "@/dataProviders/MeDataProvider.tsx";
import { activateLocale } from "@/locales/utils.ts";
import { logError } from "@/sentry.ts";
import { Flag } from "@/components/Flag.tsx";

export function LanguageToggle() {
  const { i18n } = useLingui();

  const { mutateAsync, isPending } = useEditUserProfileMutation();
  const queryClient = useQueryClient();
  const { email, firstName, lastName } = useMeData();

  const toggleLanguage = async () => {
    const newLanguage = i18n.locale === "en" ? "cs" : "en";
    try {
      await mutateAsync({
        locale: newLanguage,
        email,
        firstName: firstName ?? "",
        lastName: lastName ?? "",
      });
      await queryClient.invalidateQueries({ queryKey: [USER_PROFILE_KEY] });
      activateLocale(newLanguage);
      setTimeout(() => window.location.reload());
    } catch (error) {
      logError(error);
    }
  };

  return (
    <SidebarMenuButton onClick={toggleLanguage} className={"cursor-pointer"} disabled={isPending}>
      <div className={"flex gap-2 items-center"}>
        <Flag className={"w-[1.25rem] h-[1.25rem]"} code={i18n.locale === "en" ? "CZ" : "GB"} />
        {i18n.locale === "en" ? "Česky" : "English"}
      </div>
    </SidebarMenuButton>
  );
}
